import formatCurrency from "./format-currency";

const PaymentStatistics = (paymentArray) => {
  return paymentArray?.length > 0 ? (
    <div className="px-[24px] pt-[16px]">
      <div className="border-radius h-[5rem] w-[100%] p-3 flex justify-between bg-[var(--trans-stats-con-Sblue-bg)]">
        {paymentArray?.map((pay, index) => (
          <div key={index} className="flex gap-3 w-fit items-center">
            <div className={`p-2 rounded-[12px] ${pay?.iconConClass}`}>
              {pay?.icon}
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-[length:var(--bill-list-payMet-lab-fs)] font-[var(--bill-list-payMet-lab-fw)] text-[var(--bill-list-payMet-lab-fg)]">
                {pay?.label}
              </span>
              <div className="flex gap-2 items-center">
                <span className="text-[length:var(--bill-list-payMet-val-fs)] font-[var(--bill-list-payMet-val-fw)] text-[var(--bill-list-payMet-val-fg)]">
                  {formatCurrency(pay?.value)}
                </span>
                <span className="text-[length:var(--bill-list-payMet-desc-fs)] font-[var(--bill-list-payMet-desc-fw)] text-[var(--bill-list-payMet-desc-fg)]">
                  ({pay?.desc ?? 0} %)
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default PaymentStatistics;
